import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Fragment } from 'react';
import { ExpandableSection } from '../../components/expandableSection';
import { useAppSelector } from '../../redux/store';
import { FRIENDS_PANEL_DIVIDER_COLOR } from '../../styles/colors';
import { PanelItemDivider } from '../panelItemDivider';
import { AllFriendsPanelItem } from './allFriendsPanelItem';
export const FriendsPanelAllFriendsContainer = ({ activeContacts }) => {
    // TODO: Improve this inefficient selector:
    const allFriends = useAppSelector((state) => state.contacts.allFriends);
    if (!allFriends.length) {
        return null;
    }
    return (_jsx(ExpandableSection, { expandableSectionType: 'friends-all', colorType: 'friends', children: allFriends.map((friend, i) => (_jsxs(Fragment, { children: [i > 0 && _jsx(PanelItemDivider, { color: FRIENDS_PANEL_DIVIDER_COLOR, thicknessPx: 2 }), _jsx(AllFriendsPanelItem, { playerId: friend.id, username: friend.name, isOnline: !!activeContacts.friends?.find((currFriend) => currFriend.playerId === friend.id) })] }, i))) }));
};
